module.exports = __webpack_public_path__ + "assets/img/img_ksrq.fc471c00.png";